<template>
    <div>
        <stripe-element-payment
            ref="paymentRef"
            :pk="pk"
            :elements-options="elementsOptions"
            :confirm-params="confirmParams"
            />
        
        <br>

<!--       @todo <button 
            @click="pay"
            type="submit" 
            class="mt-4 btn btn-lg fs-5 btn-primary fw-bold text-white w-100" 
            :disabled="form.processing"
            >
            {{ __('Jetzt kaufen') }}
        </button>-->
    </div>
</template>

<script>
    import { StripeElementPayment } from '@vue-stripe/vue-stripe';
    export default {
        props: [
            'form',
        ],
        components: {
            StripeElementPayment,
        },
        data() {
            return {
                pk: 'pk_test_51L9PxJH07pmZZdzMClMHeNDFiWtWxN9Ib7xoiJKha0czJ850QhP8wuxH3uZVYJcOyhQjrgLnamfKSXDunB6Qc4pg00Bbnq1FjT',
                elementsOptions: {
                    appearance: {
                        theme: 'minimal',
                        // @todo layout: 'accordion',
                    }, // appearance options
                },
                confirmParams: {
                    // @todo
                    return_url: this.route('checkout.success', {token: 'foo'}), // success url
                },
            };
        },
        mounted() {
            this.generatePaymentIntent();
        },
        methods: {
            async generatePaymentIntent() {
//                const paymentIntent = await apiCallToGeneratePaymentIntent(); // this is just a dummy, create your own API call

//                axios.get('/test/create-payment-intent', {params: {}})
//                        .then(response => {
//                            this.elementsOptions.clientSecret = response.data.client_secret;
//                            console.log(this.elementsOptions);
//                        });

                // @todo get from api
                this.elementsOptions.clientSecret = 'pi_3MJgGfH07pmZZdzM1uzc04sN_secret_4I0qbGq30tXvo6gaharPWbZl1';

            },
            pay() {
                this.$refs.paymentRef.submit();
            },
        },
    };
</script>